import { Route, Routes } from "react-router-dom";
import TransactionReversalScreen from "./list";


export default function TransactionReversalRoutes() {
  return (
    <Routes>
      <Route path="/" element={<TransactionReversalScreen />} />
    </Routes>
  );
}
